import axios from 'axios'

export const publicClientSetup = (version: string) => {
  const api = axios.create({
    baseURL: `${process.env.NEXT_PUBLIC_API_BACKEND}/${version}`,
  })

  return api
}
